
import { Recipient } from '../../../../common/types/form'

export enum RecipientModificationAction {
    UPDATED = 'UPDATED',
    ADDED = 'ADDED',
    PRESERVED = 'PRESERVED',
    DELETED = 'DELETED',
    OVERRIDED = 'OVERRIDED'
}

//it is sorted as a decrescent order (0 is the last prority)
export const ModificationActionSorter = {
    [RecipientModificationAction.UPDATED]: 2,
    [RecipientModificationAction.OVERRIDED]: 2, //overrided and updated will not exist at the same momment
    [RecipientModificationAction.ADDED]: 0,
    [RecipientModificationAction.PRESERVED]: 1,
    [RecipientModificationAction.DELETED]: 1 //preserved and deleted will not exist at the same momment
}
export interface RecipientModifications {
    groupName: string
    errors: string[]
    actionErrors?: string[]
    action: RecipientModificationAction
    currentRecipient?: Recipient
    importedRecipient?: Recipient
}

export interface CsvToRecipientData {
    errors: string[]
    recipient: Recipient
}

export const COLUMN_SEPARATOR = ','
export const LINE_SEPARATOR = '\n'
export const VALUES_SEPARATOR = ';'
export const GROUP_NAME_FIELD = 'GROUP NAME'
export const RECIPIENTS_EMAIL_FIELD = 'RECIPIENTS'
export const LOOKUP_MACRO_FIELD = 'LOOKUP MACRO'
export const LOOKUP_KEY_FIELD = 'LOOKUP KEY'
export const CURRENT_FIELD_NUMBER = 4

export const ActionSearch = {
    clearParams: function clearParams() {
    },
    fetch: function fetch() {
    },
    more: function more() {
    },
    setQuery: function setQuery(query) {
    },
    sort: function sort(_sort, dir) {
    },
    filter: function filter(prop, value) {
    },
    showInfo: function showInfo(type) {
    }
  };